// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"e409638d","242":"e4efd380","667":"aa8b2e61","972":"e4f46fa4"}[chunkId] + ".chunk.css";
};